var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg_box"},[_c('div',{staticClass:"img_boxsss"},[_c('div',{staticClass:"nei_box"},[_c('img',{attrs:{"src":_vm._f("ImgFilter")(_vm.ite)}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }